// 使用立即执行函数表达式（IIFE）定义ProductShowCarouselManager类，避免重复声明
var ProductShowCarouselManager = (function() {
    // 类定义保持不变，只是包装在IIFE中
    class ProductShowCarouselManager {
        constructor(container) {
            this.container = container;
            this.isMobile = window.innerWidth <= 768;
            this.items = this.isMobile ? 
                this.container.querySelectorAll('.product-show-carousel-item-mobile') : 
                this.container.querySelectorAll('.product-show-carousel-item');
            this.itemTabs = this.isMobile ? 
                this.container.querySelectorAll('.product-show-carousel-item-tab .product-show-carousel-item-title') : 
                null;
            this.scrollLine = this.isMobile ? 
                this.container.querySelector('.product-show-carousel-item-tab .product-show-carousel-scroll-line') : 
                this.container.querySelector('.product-show-carousel-scroll-line');
            this.images = this.container.querySelectorAll('.product-show-carousel-img');
            this.imageWrapper = this.container.querySelector('.product-show-carousel-img-wrapper');
            this.videoWrapper = this.isMobile ? this.container.querySelector('.product-show-carousel-videos-wrapper-mobile') : this.container.querySelector('.product-show-carousel-videos-wrapper-pc');
            this.videos = this.videoWrapper ? this.videoWrapper.querySelectorAll('.product-show-carousel-video') : [];
            
            this.subtitleItems = this.isMobile ? this.items : null;
            this.eventListeners = [];
            // 触摸滑动相关变量
            this.startX = 0;
            this.currentX = 0;
            this.isDragging = false;
            this.startTime = 0;
            this.tapThreshold = 20; // 最大移动距离阈值，超过则认为是滑动而不是点击
            this.timeThreshold = 300; // 最大触摸时间阈值（毫秒）
            
            if ((this.isMobile && (!this.itemTabs || this.itemTabs.length < 1)) || 
                (!this.isMobile && this.items.length < 1)) {
                return;
            }
            
            this.init();
        }
        
        init() {
            this.hideAllSubtitles();
            this.activateFirstItem();
            this.bindEvents();
        }
        
        hideAllSubtitles() {
            if (this.isMobile) {
                this.items.forEach(item => {
                    item.style.display = "none";
                });
            } else {
                this.items.forEach(item => {
                    const subtitle = item.querySelector('.product-show-carousel-item-subtitle');
                    if (subtitle) {
                        subtitle.style.display = "none";
                    }
                });
            }
        }
        
        activateFirstItem() {
            if (!this.isMobile && this.items.length > 0) {
                this.activateItem(this.items[0], 0);
            } else if (this.isMobile && this.itemTabs && this.itemTabs.length > 0) {
                this.activateItem(this.itemTabs[0], 0);
            }
        }
        
        bindEvents() {
            if (!this.isMobile && this.items) { 
                this.items.forEach((item, index) => {
                    const handler = () => this.activateItem(item, index);
                    item.addEventListener('click', handler);
                    this.eventListeners.push({element: item, event: 'click', handler});
                });
            } else if (this.isMobile && this.itemTabs) {
                this.itemTabs.forEach((itemTab, index) => { 
                    const handler = () => this.activateItem(itemTab, index);
                    itemTab.addEventListener('click', handler);
                    this.eventListeners.push({element: itemTab, event: 'click', handler});
                });
                
                // 添加触摸滑动事件到 tab 区域
                const tabWrapper = this.container.querySelector('.product-show-carousel-item-tab-wrapper');
                if (tabWrapper) {
                    tabWrapper.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
                    tabWrapper.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: false });
                    tabWrapper.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });
                    this.eventListeners.push({element: tabWrapper, event: 'touchstart', handler: (e) => this.handleTouchStart(e)});
                    this.eventListeners.push({element: tabWrapper, event: 'touchmove', handler: (e) => this.handleTouchMove(e)});
                    this.eventListeners.push({element: tabWrapper, event: 'touchend', handler: (e) => this.handleTouchEnd(e)});
                }
                
                // 添加触摸滑动事件到图片和视频区域
                if (this.imageWrapper) {
                    this.imageWrapper.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
                    this.imageWrapper.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: false });
                    this.imageWrapper.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });
                    this.eventListeners.push({element: this.imageWrapper, event: 'touchstart', handler: (e) => this.handleTouchStart(e)});
                    this.eventListeners.push({element: this.imageWrapper, event: 'touchmove', handler: (e) => this.handleTouchMove(e)});
                    this.eventListeners.push({element: this.imageWrapper, event: 'touchend', handler: (e) => this.handleTouchEnd(e)});
                }
                
                if (this.videoWrapper) {
                    this.videoWrapper.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
                    this.videoWrapper.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: false });
                    this.videoWrapper.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });
                    this.eventListeners.push({element: this.videoWrapper, event: 'touchstart', handler: (e) => this.handleTouchStart(e)});
                    this.eventListeners.push({element: this.videoWrapper, event: 'touchmove', handler: (e) => this.handleTouchMove(e)});
                    this.eventListeners.push({element: this.videoWrapper, event: 'touchend', handler: (e) => this.handleTouchEnd(e)});
                }
            }
        }
        
        // 触摸开始事件处理
        handleTouchStart(e) {
            this.startX = e.touches[0].clientX;
            this.currentX = this.startX;
            this.isDragging = true;
            this.startTime = new Date().getTime();
        }
        
        // 触摸移动事件处理
        handleTouchMove(e) {
            if (!this.isDragging) return;
            this.currentX = e.touches[0].clientX;
            // 如果移动距离较大，阻止默认滚动行为
            if (Math.abs(this.currentX - this.startX) > 10) {
                e.preventDefault();
            }
        }
        
        // 触摸结束事件处理
        handleTouchEnd(e) {
            if (!this.isDragging) return;
            this.isDragging = false;
            
            const endTime = new Date().getTime();
            const elapsedTime = endTime - this.startTime;
            const diff = this.startX - this.currentX;
            const absDiff = Math.abs(diff);
            
            // 判断是否为点击（移动距离小且时间短）
            const isTap = absDiff <= this.tapThreshold && elapsedTime <= this.timeThreshold;
            
            // 如果是点击，则不执行滑动逻辑
            if (isTap) {
                return;
            }
            
            const minSwipeDistance = 50; // 最小滑动距离
            
            // 确定当前激活的项目
            let currentIndex = 0;
            this.itemTabs.forEach((tab, index) => {
                if (tab.classList.contains('is-active')) {
                    currentIndex = index;
                }
            });
            
            // 向左滑动 - 切换到下一个项目（一次只切换一个）
            if (diff > minSwipeDistance && currentIndex < this.itemTabs.length - 1) {
                this.activateItem(this.itemTabs[currentIndex + 1], currentIndex + 1);
                e.preventDefault(); // 阻止其他可能的滑动行为
            }
            // 向右滑动 - 切换到上一个项目（一次只切换一个）
            else if (diff < -minSwipeDistance && currentIndex > 0) {
                this.activateItem(this.itemTabs[currentIndex - 1], currentIndex - 1);
                e.preventDefault(); // 阻止其他可能的滑动行为
            }
        }
        
        activateItem(item, index) {
            const itemId = item.getAttribute('id');
            
            // 移除所有项目的激活状态
            const allItems = this.isMobile ? this.itemTabs : this.items;
            allItems.forEach(itemElement => {
                itemElement.classList.remove('is-active');
            });
            
            // 隐藏所有副标题
            if (!this.isMobile) {
                this.items.forEach(itemElement => {
                    const subtitle = itemElement.querySelector('.product-show-carousel-item-subtitle');
                    if (subtitle) {
                        subtitle.style.display = "none";
                    }
                });
            } else if (this.subtitleItems) {
                this.subtitleItems.forEach(itemElement => {
                    itemElement.style.display = "none";
                });
            }
            
            // 隐藏所有图片槽位，并暂停其中的上传视频
            this.images.forEach(image => {
                image.style.display = "none";
                this.pauseMediaElement(image);
            });
            
            // 显示当前点击项的图片槽位（图片或上传视频）
            const currentImage = this.imageWrapper
                ? this.imageWrapper.querySelector(`[rg-product-carousel-item="${itemId}"]`)
                : null;
            if (currentImage) {
                currentImage.style.display = "block";
                const shopifyVideo = currentImage.querySelector('.product-show-carousel-video');
                if (shopifyVideo) {
                    this.playMediaElement(shopifyVideo);
                }
            }

            // 隐藏并暂停 videos-wrapper 中的 GIF / 外链视频
            this.videos.forEach(mediaEl => {
                mediaEl.style.display = "none";
                this.pauseMediaElement(mediaEl);
            });
            // 显示当前点击的 GIF / 外链视频
            const currentVideo = this.videoWrapper
                ? this.videoWrapper.querySelector(`[rg-product-carousel-item="${itemId}"]`)
                : null;
            if (currentVideo) {
                currentVideo.style.display = "block";
                this.playMediaElement(currentVideo);
            }
            // 激活当前点击的项目
            item.classList.add('is-active');
            
            if (!this.isMobile) {
                const clickedSubtitle = item.querySelector('.product-show-carousel-item-subtitle');
                if (clickedSubtitle) {
                    clickedSubtitle.style.display = "block";
                }
            } else {
                // 在移动端显示对应的子标题项
                if (this.subtitleItems && this.subtitleItems[index]) {
                    this.subtitleItems[index].style.display = "block";
                }
            }
            
            // 更新滚动线位置和尺寸
            this.updateScrollLine(item);
        }
        
        updateScrollLine(item) {
            if (!this.scrollLine) return;

            if (!this.isMobile) {
                this.scrollLine.style.height = item.offsetHeight + 'px';
                this.scrollLine.style.top = item.offsetTop + 'px';
            } else {
                this.scrollLine.style.width = item.offsetWidth + 'px';
                this.scrollLine.style.left = item.offsetLeft + 'px';
                const scrollLineParent = item.parentNode;
                scrollLineParent.scrollTo({
                    left: item.offsetLeft - (scrollLineParent.offsetWidth / 2) + (item.offsetWidth / 2),
                    behavior: 'smooth'
                });
            }
        }

        getVideoNodes(mediaEl) {
            if (!mediaEl) return [];
            if (mediaEl.tagName === 'VIDEO') return [mediaEl];
            return Array.from(mediaEl.querySelectorAll('video'));
        }

        pauseMediaElement(mediaEl) {
            this.getVideoNodes(mediaEl).forEach(video => {
                video.pause();
            });
        }

        playMediaElement(mediaEl) {
            if (!mediaEl) return;

            // Shopify 上传视频：deferred-media 懒加载，仅在激活时加载
            const isDeferredMedia = mediaEl.tagName === 'DEFERRED-MEDIA';
            if (
                isDeferredMedia &&
                !mediaEl.hasAttribute('loaded') &&
                typeof mediaEl.loadContent === 'function'
            ) {
                mediaEl.loadContent(false, false, 'active');
            }

            const forceAmbientPlayback = (video) => {
                video.muted = true;
                video.defaultMuted = true;
                video.loop = true;
                video.controls = false;
                video.removeAttribute('controls');
                video.setAttribute('muted', '');
                video.setAttribute('loop', '');
                video.setAttribute('autoplay', '');
                video.setAttribute('playsinline', '');
                video.setAttribute('webkit-playsinline', '');
                video.playsInline = true;
                // 隐藏 video_tag 可能带出的 poster 图
                video.querySelectorAll('img').forEach((img) => {
                    img.hidden = true;
                });
                const play = () => video.play().catch(() => {});
                if (video.readyState >= 2) {
                    play();
                } else {
                    video.addEventListener('loadeddata', play, { once: true });
                    video.addEventListener('canplay', play, { once: true });
                    play();
                }
            };

            const tryPlay = (attempt) => {
                const videos = this.getVideoNodes(mediaEl);
                if (!videos.length) {
                    // 仅对懒加载视频重试；GIF/img 没有 video 节点
                    if (isDeferredMedia && attempt < 10) {
                        setTimeout(() => tryPlay(attempt + 1), 100);
                    }
                    return;
                }
                videos.forEach(forceAmbientPlayback);
            };

            tryPlay(0);
        }
        
        destroy() {
            // 移除所有事件监听器
            this.eventListeners.forEach(({element, event, handler}) => {
                element.removeEventListener(event, handler);
            });
            this.eventListeners = [];
        }
    }
    
    // 返回类，使其可以在外部使用
    return ProductShowCarouselManager;
})();